import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { CountdownSection } from './components/CountdownSection';
import { AboutSection } from './components/AboutSection';
import { WhyMattersSection } from './components/WhyMattersSection';
import { AcquirelySection } from './components/AcquirelySection';
import { LiveEventSection } from './components/LiveEventSection';
import { PartnersSection } from './components/PartnersSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-white font-sans selection:bg-brand-teal selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <CountdownSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <WhyMattersSection data-id="element-6" />
        <AcquirelySection data-id="element-7" />
        <LiveEventSection data-id="element-8" />
        <PartnersSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}